export enum EoiFinanceStatus {
  PRE_APPROVED = "Pre-approved'",
  PENDING = "Pending",
}
